import React, { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
function Header({ headerTheme }) {

  useEffect(() => {
    window.scrollTo(0, 0);

    var nav_link_0 = document.querySelector(".nav_link_0");
    var nav_link_1 = document.querySelector(".nav_link_1");
    var nav_link_2 = document.querySelector(".nav_link_2");
    var nav_link_3 = document.querySelector(".nav_link_3");
    var nav_link_4 = document.querySelector(".nav_link_4");
    var nav_link_5 = document.querySelector(".nav_link_5");
    var nav_link_6 = document.querySelector(".nav_link_6");
    var nav_link_7 = document.querySelector(".nav_link_7");


    if (nav_link_0.classList.contains("active")) {
      nav_link_0.classList.add("custom_active_class");
    }
    if (nav_link_1.classList.contains("active")) {
      nav_link_1.classList.add("custom_active_class");
    }
    if (nav_link_2.classList.contains("active")) {
      nav_link_2.classList.add("custom_active_class");
    }

    if (nav_link_3.classList.contains("active")) {
      nav_link_3.classList.add("custom_active_class");
    }

    if (nav_link_4.classList.contains("active")) {
      nav_link_4.classList.add("custom_active_class");
    }

    if (nav_link_5.classList.contains("active")) {
      nav_link_5.classList.add("custom_active_class");
    }

    if (nav_link_6.classList.contains("active")) {
      nav_link_6.classList.add("custom_active_class");
    }

    if (nav_link_7.classList.contains("active")) {
      nav_link_7.classList.add("custom_active_class");
    }
  }, []);
  return (
    <div className={`custom_margin_header_bottom ${headerTheme}`}>
      <div className=" sticky">
        <nav
          className="nav-1 navbar navbar-expand-lg pt-2 py-2"
          id="navbar"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 12px",
            width: "100%",
          }}
        >
          {/* KIRI — Logo */}
          <div style={{ flexShrink: 0 }}>
            {window.location.pathname.includes("products/t-opt") ? (
              <div className="navbar-brand" style={{ margin: 0 }}>
                <img src="/assets/logo-topt.png" alt="logo" style={{ height: "60px" }} />
              </div>
            ) : (
              <a
                className="navbar-brand"
                href="https://www.toyota.astra.co.id/home"
                style={{ margin: 0 }}
              >
                <img
                  src="/assets/LogoDark.svg"
                  alt="logo"
                  style={{ width: "128px", padding: "10px" }}
                />
              </a>
            )}
          </div>

          {/* HAMBURGER — hanya tampil di mobile */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* TENGAH — Menu navigasi */}
          <div
            className="collapse navbar-collapse"
            id="navbarNav"
            style={{
              flex: "1 1 auto",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {/* isi menu navbar di sini */}
          </div>

          {/* KANAN — Icon search, dealer, login */}
          <div
            className="search-img"
            style={{
              flexShrink: 0,
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <ul
              className="navbar-nav"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                margin: 0,
                padding: 0,
                gap: "4px",
              }}
            >
              {/* Search */}
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="https://www.toyota.astra.co.id/search/content"
                  style={{ padding: "0 8px" }}
                >
                  <img src="/assets/Button.png" alt="search" />
                </a>
              </li>

              {/* Find Dealer */}
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="https://www.toyota.astra.co.id/shopping-tools/dealer"
                  style={{ padding: "0 8px" }}
                >
                  <img
                    src="/assets/Icon FInd Dealer 2.png"
                    alt="find dealer"
                    style={{ margin: "-5px" }}
                  />
                </a>
              </li>
            </ul>
          </div>
        </nav>
        <nav className="navbar navbar-expand-lg navbar_bottom_custom_padding py-0">
          <div className="container-lg container-fluid px-0">
            <NavLink to="#" className="navbar-brand mx-lg-0 mx-3 navbar_bottom_custom_padding_1 py-0">
              After Sales
            </NavLink>
            <button
              className="navbar-toggler mx-lg-0 mx-3 navbar_bottom_custom_padding_2"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav2"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span>
                <img src="/assets/Down.png" />
              </span>
            </button>
            <div
              className="collapse navbar-collapse justify-content-end color_in_mobile"
              id="navbarNav2"
            >
              <ul className="navbar-nav">
                <li className="nav-item mx-0">
                  <NavLink
                    to="/"
                    className="nav-link nav_link_0 custom-border-radius  mx-3"
                    aria-disabled="true"
                  >
                    Home
                  </NavLink>
                </li>
                <li className="nav-item mx-0">
                  <div className="d-flex justify-content-between justify-content-lg-start">
                    <NavLink
                      to="/services"
                      className="nav-link nav_link_1 custom-border-radius  mx-lg-0 mx-3"
                      aria-current="page"
                    >
                      SERVICES
                    </NavLink>
                    <button
                      className="navbar-toggler mx-lg-0 mx-3 navbar_bottom_custom_padding_2 py-0"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#navbarNav3"
                      aria-controls="navbarNav3"
                      aria-expanded="false"
                      aria-label="Toggle navigation"
                    >
                      <span>
                        <img src="/assets/Down.png" />
                      </span>
                    </button>
                  </div>
                  <div className="collapse" id="navbarNav3">
                    <ul className="navbar-nav">
                      <li className="nav-item mx-3">
                        <NavLink to="/services/general-repair" className="nav-link  custom-border-radius text-white">
                          General Repair
                        </NavLink>
                      </li>
                      <li className="nav-item mx-3">
                        <NavLink to="/services/body-paint" className="nav-link custom-border-radius text-white">
                          Body & Paint
                        </NavLink>
                      </li>
                      <li className="nav-item mx-3">
                        <NavLink to="/services/toyota-mobile-service" className="nav-link custom-border-radius text-white">
                          Toyota Mobile Service
                        </NavLink>
                      </li>
                      <li className="nav-item mx-3">
                        <NavLink to="/services/express-maintenance" className="nav-link custom-border-radius text-white">
                          Express Maintenance
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="nav-item mx-0">
                  <div className="d-flex justify-content-between justify-content-lg-start">
                    <NavLink
                      to="/products"
                      className="nav-link nav_link_2 custom-border-radius mx-3"
                    >
                      PRODUCTS
                    </NavLink>
                    <button
                      className="navbar-toggler mx-lg-0 mx-3 navbar_bottom_custom_padding_2 py-0"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#navbarNav4"
                      aria-controls="navbarNav4"
                      aria-expanded="false"
                      aria-label="Toggle navigation"
                    >
                      <span>
                        <img src="/assets/Down.png" />
                      </span>
                    </button>
                  </div>
                  <div className="collapse" id="navbarNav4">
                    <ul className="navbar-nav">
                      <li className="nav-item mx-3">
                        <NavLink to="/products/service-parts" className="nav-link custom-border-radius text-white">
                          Service Parts
                        </NavLink>
                      </li>
                      <li className="nav-item mx-3">
                        <NavLink to="/products/tmo" className="nav-link custom-border-radius text-white">
                          TMO
                        </NavLink>
                      </li>
                      <li className="nav-item mx-3">
                        <NavLink to="/products/tgb" className="nav-link custom-border-radius text-white">
                          TGB
                        </NavLink>
                      </li>
                      <li className="nav-item mx-3">
                        <NavLink to="/products/tire-solution" className="nav-link custom-border-radius text-white">
                          Tire Solution
                        </NavLink>
                      </li>
                      <li className="nav-item mx-3">
                        <NavLink to="/products/t-opt" className="nav-link custom-border-radius text-white">
                          T OPT
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="nav-item mx-0">
                  <NavLink
                    to="/warranty"
                    className="nav-link nav_link_3 custom-border-radius  mx-3"
                  >
                    WARRANTY
                  </NavLink>
                </li>
                <li className="nav-item mx-0">
                  <NavLink
                    to="/t-care"
                    className="nav-link nav_link_4 custom-border-radius  mx-3"
                  >
                    T-CARE
                  </NavLink>
                </li>
                <li className="nav-item mx-0">
                  <NavLink
                    to="/hybrid-health-check"
                    className="nav-link nav_link_7 custom-border-radius  mx-3"
                  >
                    Hybrid Health Check
                  </NavLink>
                </li>
                <li className="nav-item mx-0">
                  <NavLink
                    to="/news-information"
                    className="nav-link nav_link_5 custom-border-radius  mx-3"
                  >
                    NEWS & EVENT
                  </NavLink>
                </li>
                <li className="nav-item mx-0">
                  <NavLink
                    to="/faq"
                    className="nav-link nav_link_6 custom-border-radius  mx-3"
                    aria-disabled="true"
                  >
                    FAQ
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
}

export default Header;
